export default __webpack_public_path__ + "a4d3aaf6c2e7a8ade388ed19274e3701.png";